var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3678 1.21953C12.6616 0.925781 13.1366 0.925781 13.4272 1.21953L14.7585 2.55078C15.0522 2.84453 15.0522 3.31953 14.7585 3.61016L13.0491 5.32578L10.6553 2.93203L12.3678 1.21953ZM9.9491 3.63828L12.3428 6.03203L4.9866 13.3852C4.7491 13.6227 4.45847 13.7945 4.1366 13.8883L1.2366 14.7445L2.08972 11.8445C2.18347 11.5227 2.35847 11.232 2.59285 10.9945L9.9491 3.63828ZM14.1366 0.513281C13.4522 -0.171094 12.346 -0.171094 11.6616 0.513281L1.8866 10.2852C1.53035 10.6414 1.27097 11.0789 1.13035 11.5602L0.0209741 15.3414C-0.0321509 15.5164 0.0178491 15.707 0.145974 15.8352C0.274099 15.9633 0.464724 16.0133 0.639724 15.9602L4.42097 14.8477C4.90222 14.707 5.33972 14.4445 5.69597 14.0914L15.4678 4.31953C16.1522 3.63516 16.1522 2.52891 15.4678 1.84453L14.1366 0.513281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.4dd082bcc5362576993c978ee0d1f9a3.svg";
export { ForwardRef as ReactComponent };